<template>
            <v-dialog v-model="value" scrollable persistent :max-width="maxWidth" non-linear>
                <v-card>
                    <v-card-title class="primary modal-title">
                        <span class="thin--span">Detalhe {{ tipo }}</span>
                        <v-spacer/>
                        <v-btn icon @click="fecharModal">
                            <v-icon size="20" color="white">close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text style="min-height: 350px; overflow-x: hidden">
                        <v-layout row wrap>
                            <campo-apresentacao labelPadrao="Data/Hora Criação" :text="item.dataCadastro | dataHumanizada"
                                                style="margin-right: 8%"/>

                            <campo-apresentacao labelPadrao="Data/Hora Envio" :text="item.dataEnvio | dataHumanizada"
                                                style="margin-right: 8%"/>

                            <campo-apresentacao v-if="item.fornecedor && item.fornecedor.razaoSocial" labelPadrao="Empresa" :text="item.fornecedor.razaoSocial"
                                                style="margin-right: 10%"/>
                            <campo-apresentacao v-else-if="item.nomeRazaoSocial" :labelPadrao="item.tipoPessoa === 'F' ? 'Nome':'Empresa'" :text="item.nomeRazaoSocial"
                                                style="margin-right: 10%"/>
                            <campo-apresentacao v-else labelPadrao="Empresa" :text="'--'"
                                                style="margin-right: 10%"/>

                            <campo-apresentacao labelPadrao="Situação"
                                                :text="item.situacao | azEnum(tiposSituacaoEsclarecimentoImpugnacao)"
                                                style="margin-right: 10%"/>

                          <campo-apresentacao v-if="item.tipoPessoa"
                                              :labelPadrao="item.tipoPessoa === 'F' ? 'CPF' : 'CNPJ'"
                                              :text="item.cpfCnpj"
                                              style="margin-right: 15%"/>

                          <campo-apresentacao v-if="item.tipoPessoa"
                                              labelPadrao="E-mail"
                                              :text="item.email"
                                              style="margin-right: 10%"/>
                        </v-layout>
                    <div style="margin-bottom: 20px">
                        <v-layout row wrap>
                        <campo-apresentacao
                                :labelPadrao="'Assunto ' + tipo"
                                :text="item.assunto"
                                styles="max-percent-visualizacao"
                                :tabulacao="true"
                        />
                        </v-layout>
                        <a :href="criarLinkDownload(item.arquivoUri)" v-if="item.arquivoUri" title="Download do Anexo"
                           target="_blank" class="az-action-link-icon tabulacao-content" >
                            <span class="fileDownloadResposta">Visualizar Anexo</span>
                        </a>
                    </div>
                    <div v-if="respostasDados.respostas && respostasDados.respostas.length > 0" style="margin-bottom: 20px">
                        <v-layout row wrap>
                          <label class="label-esclarecimento">Respostas {{ tipo }}</label>
                        </v-layout>
                      <div class="container-respostas-esclarecimento" v-for="resposta in respostasDados.respostas" :key="resposta.id">
                        <div class="container-balao-resposta-esclarecimento">
                          <campo-apresentacao labelPadrao="Responsável" :text="resposta.usuario.nome"
                                              style="margin-right: 8%"/>

                          <campo-apresentacao labelPadrao="Data/Hora Resposta" :text="resposta.dataCadastro | dataHumanizada"
                                              style="margin-right: 8%"/>
                          <div class="balao-resposta-esclarecimento-impugnacao" :class="{ 'balao-resposta-esclarecimento-sem-anexo' : !resposta.anexoUri && tipo != 'Impugnação' }">
                            <label>{{ resposta.resposta }}</label>
                          </div>
                          <div v-if="resposta.anexoUri || tipo === 'Impugnação'" class="balao-resposta-footer">
                            <label v-if="resposta.analise && tipo === 'Impugnação'" >{{resposta.analise | descricaoSituacaoDeferimento}}</label>
                            <div>
                              <a v-if="resposta.anexoUri" :href="criarLinkDownload(resposta.anexoUri)"  title="Download do Anexo"
                                 target="_blank" class="az-action-link-icon tabulacao-content" >
                                <v-icon>file_download</v-icon>
                              </a>
                              <label class="container-balao-resposta-anexo">{{resposta.anexoNome}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
</template>

<script>
    import {mapActions} from 'vuex'
    import {actionTypes, tiposAnexoFornecedor, tiposSituacaoEsclarecimentoImpugnacao} from '@/commons/constants'
    import CampoApresentacao from '@/commons/components/campos/campo-apresentacao.vue'

    export default {
        name: 'ModalVisualizarRespostaEsclarecimentoImpugnacao',
        components: {CampoApresentacao},
        props: {
            value: Boolean,
            item: {
                type: Object,
                default: ()=>{}
            },
            maxWidth: {
                type: String,
                default: '800'
            },
        },
        data() {
            return {
                respostasDados: [],
                tipo: null,
                colunasTabela: [
                    {
                        text: 'Data',
                        align: 'left',
                        sortable: false,
                        width: '15%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Empresa',
                        align: 'left',
                        sortable: false,
                        width: '20%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Situação',
                        sortable: false,
                        align: 'left',
                        width: '15%',
                        class: 'primary--text'
                    },
                    {
                      text: 'Deferimento',
                      sortable: false,
                      align: 'left',
                      width: '15%',
                      class: 'primary--text'
                    }
                ],
                tiposSituacaoEsclarecimentoImpugnacao
            }
        },
        async mounted() {
          await this.buscarRespostaLicitacao()
          this.tipo = this.tipoAnexoFornecedor(this.item.tipo)
        },
        methods: {
            ...mapActions([actionTypes.BUSCAR_RESPOSTA_ESCLARECIMENTO_IMPUGNACAO]),
            async buscarRespostaLicitacao(){
                if(this.item.situacao === 'RESPONDIDO') {
                    this.respostasDados = await this.buscarRespostaEsclarecimentoImpugnacao(this.item.id)
                }
            },
            fecharModal() {
                this.$emit('fecharModalVisualizacao')
            },
            tipoAnexoFornecedor(tipoAnexoChave) {
              const tipoSelecionado = tiposAnexoFornecedor.find(tipoObj => tipoObj.chave === tipoAnexoChave)
              return tipoSelecionado ? tipoSelecionado.label : ''
            }
        },
        filters: {
          descricaoSituacaoDeferimento(situacao){
            if (!situacao)
              return '';
            return situacao.charAt(0).toUpperCase() + situacao.toLowerCase().slice(1);
          }
        }
    }
</script>

<style lang="stylus">

    .max-percent-visualizacao
        max-width 98%

    .thin
        height 55px
        justify-content space-between
        align-content center

    .header
        margin 10px 20px
        color #777777 !important

    .fileDownloadResposta
        font-size 13px
        margin 0
        border-bottom 1px solid #1145ff
        color #1145ff

    .label-esclarecimento
        font-size 14px
        font-weight bold
        color #3A6861 !important

    .container-respostas-esclarecimento
        width 100%

    .container-balao-resposta-esclarecimento
        margin 5px

    .data-resposta-esclarecimento
        font-size 12px

    .balao-resposta-esclarecimento-impugnacao
        background-color rgb(209, 212, 212)
        border-radius 5px 5px 0px 0px
        padding 5px
        padding-bottom 0px
        min-height 30px

    .balao-resposta-esclarecimento-sem-anexo
        border-radius 5px

    .balao-resposta-footer
        border-radius 0px 0px 5px 5px
        padding 5px
        height 30px
        background-color #E8E8E8
        display flex
        justify-content space-between

    .container-balao-resposta-anexo
        font-size 12px

    .texto-conteudo
      font-size 14px
      color #777 !important
</style>